import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a44b6d46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activateButton('user'))),
      class: _normalizeClass(["num", {activeSpan: _ctx.activeButton === 'user'}])
    }, "1", 2),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activateButton($event.target.value))),
      value: "user",
      class: _normalizeClass({active: _ctx.activeButton==='user'})
    }, " Benutzername ", 2),
    _hoisted_2,
    _createElementVNode("span", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeStep('company'))),
      class: _normalizeClass(["num", {activeSpan: _ctx.activeButton === 'company'}])
    }, "2", 2),
    _createElementVNode("button", {
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activateButton($event.target.value))),
      value: "company",
      class: _normalizeClass({active: _ctx.activeButton==='company'}),
      disabled: !_ctx.finishedButton2.disabled
    }, "Unternehmen ", 10, _hoisted_3),
    _hoisted_4,
    _createElementVNode("span", {
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeStep('contact'))),
      class: _normalizeClass(["num", {activeSpan: _ctx.activeButton === 'contact'}])
    }, "3", 2),
    _createElementVNode("button", {
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activateButton($event.target.value))),
      value: "contact",
      class: _normalizeClass({active: _ctx.activeButton==='contact'}),
      disabled: !_ctx.finishedButton3.disabled
    }, "Ansprechpartner ", 10, _hoisted_5),
    _hoisted_6,
    _createElementVNode("span", {
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeStep('result'))),
      class: _normalizeClass(["num", {activeSpan: _ctx.activeButton === 'result'}])
    }, "4", 2),
    _createElementVNode("button", {
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.activateButton($event.target.value))),
      value: "result",
      class: _normalizeClass({active: _ctx.activeButton==='result'}),
      disabled: !_ctx.finishedButton4.disabled
    }, "Abschluss ", 10, _hoisted_7)
  ]))
}